import { Skeleton } from "antd";
import React from "react";
import styles from "./SkeletonUi.module.scss";

export const SkeletonUi = ({
  height = "100%",
  width = "100%",
  animation = "pulse",
  variant = "rectangular",
  darkMode = true,
  style,
}) => {
  return (
    <div
      className={`${styles.skeleton} 
        ${darkMode ? styles.dark : ""} 
        ${animation === "wave" ? styles.waveAnimation : styles.pulseAnimation} 
        ${
          variant === "rectangular"
            ? styles.rectangular
            : variant === "pie"
            ? styles.pie
            : styles.circular
        }`}
      style={{ height, width, ...style }}
    >
      <Skeleton active title={false} paragraph={false} />
    </div>
  );
};
